import { newrelic } from '@sword-health/ui-core'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createApp, type App, type Component } from 'vue'
import VueClipboard from 'vue-clipboard2'
import { InlineSvgPlugin } from 'vue-inline-svg'
import AppRoot from '@/App.vue'
import directives from '@/directives'
import dayjs from '@/plugins/dayjs'
import groupHandler from '@/plugins/group-control'
import '@/utils/zod/zod-extensions'
import GlobalComponents from '@/plugins/global-components'
import router from '@/router'
import { i18n } from '@/scripts/app-configs/i18n-config'
import { queryClient } from '@/scripts/app-configs/vue-query-default-config'
import { Vuelidate, vuelidateErrorExtractor, vuelidateErrorExtractorOpts, InputErrorWuk } from '@/scripts/app-configs/vuelidate-config'
import store from '@/store'
import { startNewrelicScript, trackNewrelicJSError } from '@/utils/newrelic'
import UI, { SwordTheme } from '@swordhealth/ui'
import { FV_DEFAULTS } from './constants/floating-vue'

import '@/styles/tailwind.scss'
import '@/styles/main.scss'

newrelic.listen()
startNewrelicScript()

const app = createApp(AppRoot as unknown as Component)

// TEMP. BEFORE REMOVING ALL 'this.$store' FROM OPTIONS API
app.use({
  install(app: App) {
    app.config.globalProperties.$store = store
  },
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
app.use(store as any)
app.use(i18n)
app.use(router)
app.use(directives)
app.use(groupHandler)
app.use(dayjs)
app.use(GlobalComponents)
app.use(InlineSvgPlugin)
app.use(VueClipboard)
app.use(VueQueryPlugin, { queryClient })
// eslint-disable-next-line @typescript-eslint/no-explicit-any
app.use(Vuelidate as any)
app.use(vuelidateErrorExtractor, vuelidateErrorExtractorOpts)
app.use(UI, {
  theme: SwordTheme,
  floatingVueConfig: { global: FV_DEFAULTS },
})
app.component('InputErrorWuk', InputErrorWuk as unknown as Component)

app.config.errorHandler = (err, vm, info) => {
  trackNewrelicJSError(err, { info })
  console.error(err)
}

app.mount('#app')
